/* Show complete product facts only when they fit on one line. No guesses or shortened values. */
if (!customElements.get('wpa-product-details')) {
  customElements.define('wpa-product-details', class extends HTMLElement {
    connectedCallback() {
      this.fit = this.fit.bind(this);
      this.observer = new ResizeObserver(this.fit);
      this.observer.observe(this);
      document.fonts?.ready.then(() => { if (this.isConnected) this.fit(); });
      this.fit();
    }

    disconnectedCallback() { this.observer?.disconnect(); }

    fit() {
      const list = this.querySelector('.wpa-specs');
      if (!list) return;
      const width = list.getBoundingClientRect().width;
      if (!width) return;
      this.setAttribute('data-fitted', '');
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      let used = 0;
      let visible = 0;
      for (const item of list.children) {
        item.hidden = false;
        item.classList.toggle('wpa-specs__following', visible > 0);
        const needed = item.getBoundingClientRect().width + (visible ? gap : 0);
        item.hidden = used + needed > width;
        if (!item.hidden) { used += needed; visible++; }
      }
    }
  });
}
